export default __webpack_public_path__ + "static/media/Gloves of the Warded Brute.80b42974.jpg";